import { MobileWizardStateRecord } from '@frontend/wizard/mobile';
import { ScreenType } from '@frontend/wizard/types';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../redux/store';
import { useKioskNavigate } from '../../utils/kiosk-navigation';

interface ViewProps {
    screen_type: ScreenType;
    currentWizardState: MobileWizardStateRecord | null;
    isLoading: boolean;
}

const useScreenRenderer = (): ViewProps => {
    const { wizardId, screen_type } = useParams<{ wizardId: string; screen_type: ScreenType }>();
    const wizardStore = useAppSelector((state) => state.wizards);
    const navigate = useKioskNavigate();
    const [isLoading, setIsLoading] = useState(true);

    const currentWizardState = wizardId ? wizardStore[wizardId] : undefined;

    useEffect(() => {
        if (!wizardId || currentWizardState === undefined) {
            console.log('Wizard store not found, navigating to home');
            navigate('../../');
        } else {
            setIsLoading(false);
        }
    }, [wizardId, currentWizardState, navigate]);

    //Fallback navigation
    useEffect(() => {
        if (screen_type === ScreenType.HOME) {
            currentWizardState?.from ? navigate(currentWizardState.from) : navigate('/');
        }
        if (screen_type === ScreenType.PREVIOUS) {
            navigate(-1);
        }
    }, [screen_type]);

    return {
        screen_type: screen_type as ScreenType,
        currentWizardState: currentWizardState || null,
        isLoading
    };
};

export default useScreenRenderer;
